// Eskom PARCC — the one mapping between the two review signals.
//
// A transaction's "reviewed-ness" is stored TWICE — a boolean `Transaction.reviewed`
// (what the register/detail read via `isReviewed`) and a free-text `reviewStatus` string
// (what Working Papers / Findings / Allocation read). They MUST move together, or a row
// looks reviewed on one surface and not on another (the Jul 8 "un-review won't stick"
// bug). This helper derives the boolean from the status so every write path can keep the
// two in lock-step; `isReviewed` (features/transactions/editTransaction) is the read-side
// twin of the same mapping.
//
// A status counts as reviewed when it begins with "reviewed" — covers "Reviewed" and the
// imported "Reviewed with Findings". "Not Reviewed" / "Pending Review" / "In Progress" /
// blank are not reviewed.
export function reviewedFlagForStatus(status: string | null | undefined): boolean {
  return (status ?? '').trim().toLowerCase().startsWith('reviewed');
}
